module.exports = new __parcel__URL__("smart_metering.a578589a.png").toString();